import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

export default function SettingLayout({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const tabs = [
    {
      id: "settings",
      title: "Business",
      icon: "ri-home-gear-line",
      path: "/settings",
      activePaths: ["/settings"],
    },
    {
      id: "additionalDetails",
      title: "Addition Details",
      icon: "ri-settings-2-line",
      path: "/settings/addition/details",
      activePaths: ["/settings/addition/details"],
    },
    {
      id: "config",
      title: "Configuration",
      icon: "ri-tools-fill",
      path: "/app/configuration",
      activePaths: ["/app/configuration"],
    },
    {
      id: "razorpay",
      title: "Razorpay Settings",
      icon: "ri-bank-card-line",
      path: "/settings/razorpay",
      activePaths: ["/settings/razorpay"],
    },
    {
      id: "profile",
      title: "Profile",
      icon: "ri-account-circle-line",
      path: "/profile",
      activePaths: ["/profile"],
    },
  ];

  const permittedTabs = tabs
    .map((tab) => {
      const accessiblePaths = tab.activePaths.filter((route) =>
        hasAccess(route)
      );

      return {
        ...tab,
        path: accessiblePaths[0] || "/",
        access: accessiblePaths.length > 0,
      };
    })
    .filter((tab) => tab.access);

  return (
    <>
      <ModuleHeader tabs={permittedTabs} />
      {children}
    </>
  );
}